<template>
  <div>
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <CRow>
      <CCol sm="12">
        <CCard>
          <CCardHeader>
            <strong>Add Feedback Questions</strong>
          </CCardHeader>
          <CCardBody>
            <CForm class="formData">
              <CRow>
                <CCol sm="12">
                  <label class="m-0 col-fonts-black">Select Role</label>
                </CCol>
                <CCol sm="12" class="mb-3">
                  <select class="v-select" id="rollselect">
                    <option v-for="role in modulesArr" :value="role.Module_Id">
                      {{ role.ModuleName }}
                    </option>
                  </select>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12">
                  <CInput
                    label="Purpose"
                    id="purpose"
                    placeholder="Purpose"
                    name="purpose"
                  />
                </CCol>
              </CRow>

              <div id="newQustions">
                <hr />
                <CRow>
                  <CCol sm="12">
                    <label class="m-0 col-fonts-black">Question</label>
                  </CCol>
                  <CCol sm="12" class="mb-3">
                    <textarea
                      class="question_class form-control"
                      id="question_0"
                      rows="2"
                      placeholder="Enter question"
                    ></textarea>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <label class="m-0 col-fonts-black">Question Type</label>
                  </CCol>
                  <CCol sm="12" class="mb-3">
                    <select
                      class="v-select form-control type_class"
                      id="type_0"
                    >
                      <option v-for="qtypes in question_types">
                        {{ qtypes }}
                      </option>
                    </select>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <CInput
                      label="Value"
                      id="answer_type_0"
                      class="answer_value_class"
                      placeholder="Answer Comma Separated"
                      name="answer_value"
                    />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol sm="12">
                    <label class="m-0 col-fonts-black">Enable/Disable</label>
                  </CCol>
                  <CCol sm="12" class="mb-3">
                    <select
                      class="v-select form-control status_class"
                      id="status_0"
                    >
                      <option v-for="sts in status">{{ sts }}</option>
                    </select>
                  </CCol>
                </CRow>
              </div>

              <CRow>
                <CCol sm="6"> </CCol>
                <CCol sm="6">
                  <button
                    aria-pressed="true"
                    type="button"
                    autocomplete="off"
                    class="
                      btn btn-outline-light btn-block
                      active
                      fw-300
                      col-white
                      fs-18
                    "
                    @click="addMore()"
                  >
                    Add Question
                  </button>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="6" class="m-10">
                  <button
                    aria-pressed="true"
                    type="button"
                    autocomplete="off"
                    class="
                      btn btn-outline-light btn-block
                      active
                      fw-500
                      col-white
                      fs-18
                    "
                    @click="back()"
                  >
                    Cancel
                  </button>
                </CCol>
                <CCol sm="6">
                  <button
                    aria-pressed="true"
                    type="button"
                    autocomplete="off"
                    class="
                      btn btn-outline-info btn-block
                      active
                      fw-500
                      col-white
                      fs-18
                    "
                    @click="submit()"
                  >
                    Save
                  </button>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<style>
hr {
  border: 2px solid #ccc;
}
</style>


<script>
//import { ModelSelect } from 'vue-search-select';
import axios from "axios";
export default {
  name: "Add_questions",
  data() {
    return {
      roleOptions: [],
      status: ["Enable", "Disable"],
      question_types: ["Text", "Radio", "Dropdown", "Rating", "Checkbox"],
      modulesArr: [],
      roleArr: [],
      question_inx: 0,
	  isLoading: false
    };
  },
  mounted() {
	this.isLoading = true;
    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
    var self = this;
    var requestInfo = {
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "ManageModule/GetModuleList",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((result) => {
		   this.isLoading = false;
        if (result.data.status_code == 200) {
          var obj = result.data.response;
          //console.log(obj)
          // var modulecheckArr=obj;
          self.modulesArr = obj;
          // console.log(obj);
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      })

      .catch((error) => {
		  this.isLoading = false;
        //var errorObject=JSON.stringify(error.response.data.errors);
        //console.log(errorObject);
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
      });
  },
  computed: {},
  methods: {
    validator(val) {
      return val ? val.length >= 4 : false;
    },
    back() {
      this.$router.push({ path: "Manage_assign_module" });
    },
    addMore() {
      console.log("callll");
      //var newel = $('#newQustions').clone();
      //$('#cloneDiv').clone().appendTo("#newQustions");

      this.question_inx = this.question_inx + 1;
      var newQ =
        '<hr/><div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Question</label></div><div class="mb-3 col-sm-12"><textarea id="question_' +
        this.question_inx +
        '" rows="2" class="question_class form-control" placeholder="Enter question"></textarea></div></div>' +
        '<div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Question Type</label></div><div class="mb-3 col-sm-12"><select id="type_' +
        this.question_inx +
        '" class="v-select form-control type_class"><option>Text</option><option>Radio</option><option>Dropdown</option><option>Rating</option><option>Checkbox</option></select></div></div>' +
        '<div class="row"><div class="col-sm-12"><div role="group" class="form-group"><label for="answer_type_0"> Value </label><input id="answer_type_' +
        this.question_inx +
        '" type="text" placeholder="Answer Comma Separated" name="answer_value" class="form-control answer_value_class"></div></div></div>' +
        '<div class="row"><div class="col-sm-12"><label class="m-0 col-fonts-black">Enable/Disable</label></div><div class="mb-3 col-sm-12"><select id="status_' +
        this.question_inx +
        '" class="v-select form-control status_class"><option>Enable</option><option>Disable</option></select></div></div>';

      $("#newQustions").append(newQ);
    },
    submit() {
	this.isLoading = true;
      // console.log(value)
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var token = localStorage.getItem("auth");

      var Module_Id = $("#rollselect").val();
      var purpose = $("#purpose").val();
      var questionArr = [];
      $(".question_class").each(function () {
        var question_val = $(this).val();
        if (question_val != "") {
          var qattr = $(this).attr("id");
          var sids = qattr.split("_");
          var inxID = sids[1];

          var question_type = $("#type_" + inxID).val();
          var getstatus = $("#status_" + inxID).val();

          var status_flag = 0;
          if (getstatus == "Enable") {
            status_flag = 1;
          }
          var answer_type = $("#answer_type_" + inxID).val();
          var qreq = {
            question_type: question_type,
            question: question_val,
            values: answer_type,
            status: status_flag,
          };

          questionArr.push(qreq);
        }
      });

      var requestInfo = {
        Token: token,
        Session_User_Id: Session_User_Id,
        Module_Id: parseFloat(Module_Id),
        purpose: purpose,
        loQuestions: questionArr,
      };

      /*var requestInfo = {
		  Token:token,
		  Session_User_Id:Session_User_Id,
		  Module_Id:Module_Id,
		  purpose:purpose,
		  FeedBackQuestion:questionArr
		};*/

      var self = this;
      // console.log(requestInfo);

      var data = JSON.stringify(requestInfo);
      console.log(data);
      //	return false;
      var config = {
        method: "post",
        //url: apiURL+'MasterData/addFeedBackForm',
        url: feedbackApiURL + "addFeedBack",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios(config)
        .then((result) => {
          console.log(result);
		  this.isLoading = false;
          if (result.data.status_code == 200) {
            self.$swal.fire("Saved", result.data.message, "success");
            $(".formData")[0].reset();
          } else {
            self.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: result.data.message,
            });
          }
        })
        .catch((error) => {
		  this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },
  },
};
</script>
